import React, { useEffect, useState } from "react";
import { memo } from "react";

const Scanner = memo(() => {
  return <>Scanner</>;
});

export default Scanner;
